import React from 'react';
import * as ReactDOM from 'react-dom';

import { Card } from './ParticipantsComponents';

class ParticipantCardsPlaceholder extends React.Component {
  componentDidMount() {
    let elem = ReactDOM.findDOMNode(this);
    elem.style.opacity = 0;
    window.requestAnimationFrame(function() {
      elem.style.transition = 'opacity 800ms';
      elem.style.opacity = 1;
    });
  }

  render() {
    return (
      <div className="placeholder-student-card">
        <Card>
          <div className="placeholder-content">
            <div className="animated-background-students" />
            <div className="background-masker masker-right-picture" />
            <div className="background-masker masker-top-text" />
            <div className="background-masker masker-bottom-text" />
            <div className="background-masker masker-bottom-icon" />
            <div className="background-masker masker-right-icon" />
          </div>
        </Card>
      </div>
    );
  }
}

export default ParticipantCardsPlaceholder;
